module.exports = __webpack_public_path__ + "static/UnclickCommonCircle-050f7a5a502dec8fe502f4dcb8f391ad.png";